<!-- Used to detect virus mail, adding mail and if is there any
outgoing or incoming mail with that email address then it can send an alert to admin, sender or receiver
component used in VirusSetting.vue
In (UI) System Settings-> Virus Settings
-->
<template>
  <div>
    <VirusStateHeader
      :preferenceText="preferenceText"
      :toggleTab="toggleTab"
      @toggleTab="toggleTab = !toggleTab"
    />
    <v-row v-if="toggleTab">
      <v-col>
        <v-row>
          <v-col sm="6" v-if="!initialLoading">
            <Checkbox
              v-model="checkboxReceiverSender"
              :title="`Send an email warning to the ${
                preferenceText === 'Incoming' ? 'Receiver' : 'Sender'
              }`"
              theme="light"
            ></Checkbox>
          </v-col>
          <v-col sm="6" v-else>
            <v-skeleton-loader
              type="heading"
              :loading="true"
            ></v-skeleton-loader>
          </v-col>
          <v-col sm="6" v-if="!initialLoading">
            <Checkbox
              v-model="checkboxAdmin"
              title="Send email warning to an administrator:"
              theme="light"
            ></Checkbox>
          </v-col>
          <v-col sm="6" v-else>
            <v-skeleton-loader
              type="heading"
              :loading="true"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col sm="6" v-if="!initialLoading">
            <v-text-field
              label="Type email (e.g. user@company.com) & press enter"
              solo
              flat
              filled
              background-color="#E5E5E5 !important"
              v-model.trim="emailText"
              @keyup.enter="addEmail"
            ></v-text-field>
          </v-col>
        </v-row>
        <EmailTagsContainer
          :emails="emails"
          :initialLoading="initialLoading"
          @removeEmail="removeEmail($event)"
        />
        <v-row v-if="!initialLoading">
          <v-col class="text-right">
            <x-button
              outline
              color="#58e2c2"
              @click="getVirusSetting"
              buttonText="Reset"
            />
            <x-button
              color="#58e2c2"
              @click="openConfirmBox"
              :buttonText="`Save Virus ${preferenceText} settings`"
              class="w-auto ml-2"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <VirusStateDialog
      :confirmDialogueVar="confirmDialogueVar"
      :preferenceText="preferenceText"
      :preferenceKey="preferenceKey"
      :preferenceId="preferenceId"
      :checkboxAdmin="checkboxAdmin"
      :checkboxReceiverSender="checkboxReceiverSender"
      :emails="emails"
      :virusId="virusId"
      @cancelSaveSetting="cancelSaveSetting"
      @setVirusSetting="setVirusSetting($event)"
    />
  </div>
</template>

<script>
import Checkbox from '@/components/Common/Checkbox';
import EmailTagsContainer from '@/components/SysSettings/VirusSetting/EmailTagsContainer';
import VirusStateHeader from '@/components/SysSettings/VirusSetting/VirusStateHeader';
import VirusStateDialog from '@/components/SysSettings/VirusSetting/VirusStateDialog';
import PreferencesService from '@/services/PreferencesService';
var findIndex = require('lodash.findindex');
var filter = require('lodash.filter');
export default {
  props: {
    preferenceId: {
      type: String,
    },
    preferenceText: {
      type: String,
    },
    preferenceKey: {
      type: String,
    },
  },
  components: {
    Checkbox,
    EmailTagsContainer,
    VirusStateHeader,
    VirusStateDialog,
  },
  data() {
    return {
      checkboxAdmin: false,
      checkboxReceiverSender: false,
      emailText: '',
      confirmDialogueVar: false,
      emails: [],
      virusId: '',
      toggleTab: true,
      initialLoading: false,
    };
  },
  methods: {
    // to get the virus setting
    async getVirusSetting() {
      this.emails = [];
      this.emailText = '';
      this.initialLoading = true;
      try {
        let response = await PreferencesService.getPreferencesByPreferenceKey(
          this.preferenceId
        );
        let parsedResponse = this.parseResponse(response);
        this.setVirusSetting({parsedResponse, parsedResponseData:parsedResponse[0].results[0]});
      } catch (err) {
        this.snackbar('error', err);
        this.initialLoading = false;
      }
    },
    setVirusSetting({parsedResponse, parsedResponseData, action}) {
      if (parsedResponse !== false) {
        if (this.preferenceKey === 'incomingSettings') {
          this.checkboxReceiverSender =
            parsedResponseData.data[
              this.preferenceKey
            ].SEND_AN_EMAIL_WARNING_TO_THE_RECEIVER;
        } else {
          this.checkboxReceiverSender =
            parsedResponseData.data[
              this.preferenceKey
            ].SEND_AN_EMAIL_WARNING_TO_THE_SENDER;
        }
        this.checkboxAdmin =
          parsedResponseData.data[
            this.preferenceKey
          ].SEND_EMAIL_WARNING_TO_AN_ADMINISTRATOR;
        this.emails = parsedResponseData.data[this.preferenceKey].EMAILS;
        this.virusId = parsedResponseData.id;
        if (action === 'saveVirusSetting') {
          this.snackbar('success', this.$message.SAVED_SUCCESS);
        }
      } else {
        this.snackbar('error', this.$message.CANNOT_LOAD_SETTING_DATA);
      }
      if (action === 'saveVirusSetting') {
        this.confirmDialogueVar = false;
        this.emailText = '';
      } else {
        this.initialLoading = false;
      }
    },
    // to set confirm dialog box data
    openConfirmBox() {
      this.confirmDialogueVar = true;
    },
    // to close the confirm dialog without saving new virus settings
    cancelSaveSetting() {
      this.confirmDialogueVar = false;
    },
    // to add email tag
    addEmail() {
      if (this.emailValidate(this.emailText)) {
        let index = findIndex(this.emails, (email) => {
          return email === this.emailText;
        });
        if (index < 0) {
          this.emails.push(this.emailText);
          this.emailText = '';
        } else {
          this.snackbar('error', 'Email already added');
        }
      } else {
        this.snackbar('error', this.$message.INVALID_EMAIL1);
      }
    },
    /**
     * to remove email tag
     * @param {String} value
     */
    removeEmail(value) {
      this.emails = filter(this.emails, (email) => {
        return email !== value.trim();
      });
    },
  },
  mounted() {
    this.getVirusSetting();
  },
  watch: {
    currentlySelectedOrgId: function () {
      this.getVirusSetting();
    },
  },
};
</script>
